import axios, { AxiosInstance, AxiosRequestConfig, AxiosResponse, InternalAxiosRequestConfig } from "axios";
import { store } from "../Controllers/Store";
import { setError } from "../Controllers/Slices/errorSlice";
import { baseURL } from "./ApiConstant";


const apiClient : AxiosInstance = axios.create({
    baseURL: baseURL,
    timeout: 100000,
    headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
    },
})

apiClient.interceptors.request.use(
    (config: AxiosRequestConfig | InternalAxiosRequestConfig) => {
      const token = localStorage.getItem('token');
      
      // Ensure headers are defined and properly typed
      if (token && config.headers) {
        (config.headers as Record<string, string>).Authorization = `Bearer ${token}`;
      }
  
      return config as InternalAxiosRequestConfig;
    },
    (error) => {
      return Promise.reject(error);
    }
  );

  apiClient.interceptors.response.use(
    (response: AxiosResponse) => {
      
      return response;
    },
    (error) => {
      if (error.response && error.response.status === 422) {
        // Return the error response data as a resolved promise
        store.dispatch(setError({status: 401, message: 'Please check your connection.'}))
        return Promise.resolve(error.response);
      } else if (error.response) {
        // Handle specific status codes as needed
        switch (error.response.status) {
          case 401:
            // Unauthorized, possibly redirect to login
            console.error("Unauthorized access - maybe redirect to login.");
            store.dispatch(setError({status: 401, message: 'Please check your connection.'}))
            break;
          case 403:
            console.error("Forbidden - insufficient permissions.");
            store.dispatch(setError({status: 403, message: 'Please check your connection.'}))
            break;
          case 422:
          // Unauthorized, possibly redirect to login
          console.error("Unauthorized access - maybe redirect to login.");
          store.dispatch(setError({status: 422, message: 'Please check your connection.'}))
          break;
          case 500:
            console.error("Server error - try again later.");
            store.dispatch(setError({status: 500, message: 'Please check your connection.'}))
            break;
          default:
            console.error("An error occurred:", error.response.data?.message || error.message);
            store.dispatch(setError({status: 0, message: 'Please check your connection.'}))
        }
      } else {
        // Network or timeout error
        console.error("Network error - please check your connection.");
        store.dispatch(setError({status: 100, message: 'Please check your connection.'}))
        
      }
      return Promise.reject(error);
    }
  );

  export default apiClient;
